// The "Voting as ___" name on the shared poll page: asked once, remembered on
// this device. Storage can be missing or throw (private mode, blocked site
// data), so every access is guarded and the page works without it.

const NAME_KEY = 'voto_voter_name';
const ASKED_KEY = 'voto_voter_name_asked';

export function readVoterName() {
  try {
    return window.localStorage.getItem(NAME_KEY) || '';
  } catch (_) {
    return '';
  }
}

export function wasVoterNameAsked() {
  try {
    return window.localStorage.getItem(ASKED_KEY) === '1';
  } catch (_) {
    return false;
  }
}

export function saveVoterName(name) {
  const clean = String(name || '').trim().slice(0, 40);
  try {
    if (clean) window.localStorage.setItem(NAME_KEY, clean);
    else window.localStorage.removeItem(NAME_KEY);
    window.localStorage.setItem(ASKED_KEY, '1');
  } catch (_) {}
  return clean;
}
